export type DexBuySellNativeRouteOptions = {
  settle_in_native?: boolean;
};

export const readDexBuySellNativeRouteEnabled = (options: DexBuySellNativeRouteOptions) =>
  options.settle_in_native === true;

export const formatDexBuySellNativeRoute = (options: DexBuySellNativeRouteOptions) =>
  readDexBuySellNativeRouteEnabled(options) ? 'Enabled' : 'Disabled';
